import { render, staticRenderFns } from "./ForgetPasswordForm.vue?vue&type=template&id=29bdde9c&scoped=true&"
import script from "./ForgetPasswordForm.vue?vue&type=script&lang=js&"
export * from "./ForgetPasswordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bdde9c",
  null
  
)

export default component.exports